import { CompilationPlayerTrack } from '@heardis/stream-contracts';
import { useEffect, useState } from 'react';
import NotesIcon from '../../../../../elements/icons/NotesIcon';
import PauseButton from '../../../../../elements/PauseButton';
import PlayButton from '../../../../../elements/Playbutton';
import SpotifyButton from '../../../../../elements/SpotifyButton';
import { classNames } from '../../../../../utils/styles';
import { TracklistAction, TracklistActionType } from '../tracklist.types';
import classes from './TracklistItem.module.css';

/** @todo remove context and expect everything coming as a prop from <Tracklist> and define a callback `onUserAction` or similar that cover play/pause/goto */
type TracklistItemProps = {
  track: CompilationPlayerTrack;
  index: number;
  isCurrentTrack: boolean;
  isPlaying: boolean;
  showAllDetails: boolean;
  notesEnabled: boolean;
  spotifyEnabled: boolean;
  handleUserInteraction: (action: TracklistAction) => void;
};

function TracklistItem({ notesEnabled, spotifyEnabled, track, index, isCurrentTrack, showAllDetails, handleUserInteraction, isPlaying }: TracklistItemProps): JSX.Element | null {
  const [notesVisible, setNotesVisible] = useState(false);
  const showSpotifyButton = spotifyEnabled && !!track.spotifyId;
  const showNotesButton = notesEnabled && !!track.notes;

  useEffect(() => {
    setNotesVisible(showAllDetails);
  }, [showAllDetails]);

  return (
    <article className={classNames(classes.tracklistItem, isCurrentTrack ? classes.isPlaying : '')}>
      <div className={classes.trackRow}>
        {isCurrentTrack && (
          <div className={classes.actionButtonWrapper}>
            {isPlaying ?
              <PauseButton onClick={() => handleUserInteraction({ type: TracklistActionType.PAUSE })} /> :
              <PlayButton onClick={() => handleUserInteraction({ type: TracklistActionType.PLAY })} /> }
          </div>
        )}
        <button className={classes.titleArtistWrapper} type="button" onClick={() => handleUserInteraction({ type: TracklistActionType.GO_TO_TRACK, index })}>
          <p className={classes.title}>{track.title}</p>
          <p className={classes.artist}>{track.artist}</p>
        </button>
        {(showSpotifyButton || showNotesButton) && (
        <div className={classes.trackControls}>
          {showSpotifyButton && <SpotifyButton spotifyId={track.spotifyId!} onClick={() => handleUserInteraction({ type: TracklistActionType.LINK_TO_SPOTIFY, trackId: track.id })} />}
          {showNotesButton && (
          <NotesIcon onClick={() => {
            setNotesVisible(!notesVisible);
            handleUserInteraction({ type: TracklistActionType.SHOW_NOTES, trackId: track.id });
          }}
          />
          )}
          {/**
           * @TODO the download is currently not working as the trackuri of the tracks is missing in the tracklist.
           * In case of the download it could make sense to also use the handleUserInteraction to track which tracks are downloaded by click.
           * {downloadEnabled && track.trackUri && <DownloadButton url={track.trackUri} />}
          */}
        </div>
        )}
      </div>
      {notesVisible && track.notes && (
      <aside>
        <p className={classes.trackNotes}>
          <NotesIcon />
          {track.notes}
        </p>
      </aside>
      )}
    </article>
  );
}

export default TracklistItem;
